export default (axios, config) => ({
  async getProductsDeliveryNew(productId) {
    const { data } = await axios.get(
      `${config.API_URL}/delivery/getProductsDeliveryNew?productId=${productId}`,
    );
    return data;
  },
});
